import "./Contact.module.css";
import MainNavigation from "@/reusable_sections/Header";
import DirectEngineeringSupport from "./sections/DirectEngineeringSupport";
import ServiceArea from "./sections/ServiceArea";
import SiteFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <MainNavigation />
      <DirectEngineeringSupport />
      <ServiceArea />
      <SiteFooter />
    </div>;
}